import { useScreenSize } from '@myosh/odin-components';
import { lazy } from 'react';
import type { UserRecordLinkProps } from '../../../utils/linked-user-utils';
import LazyLoadedPage from '../../layout/routes/lazy-loaded-page.component';
import UserRecordLink from './user-record-link.component';

const MobileUserRecordLink = lazy(() => import('./user-record-link-mobile.component'));

export default function UserRecordLinkBase({
  id,
  label,
  readOnly,
  required,
  value,
  onChange,
  recordLinkFormat,
  buttonCaption,
  showSelectButton,
  createExternalUsers,
  saveRecord,
  error,
}: UserRecordLinkProps) {
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <LazyLoadedPage
        page={
          <MobileUserRecordLink
            id={id}
            label={label}
            value={value}
            readOnly={readOnly}
            required={required}
            recordLinkFormat={recordLinkFormat}
            buttonCaption={buttonCaption}
            showSelectButton={showSelectButton}
            createExternalUsers={createExternalUsers}
            onChange={onChange}
            saveRecord={saveRecord}
            error={error}
          />
        }
      />
    );
  } else {
    return (
      <UserRecordLink
        id={id}
        label={label}
        value={value}
        readOnly={readOnly}
        required={required}
        recordLinkFormat={recordLinkFormat}
        buttonCaption={buttonCaption}
        showSelectButton={showSelectButton}
        createExternalUsers={createExternalUsers}
        onChange={onChange}
        saveRecord={saveRecord}
        error={error}
      />
    );
  }
}
